import { render, staticRenderFns } from "./allNewDetails.vue?vue&type=template&id=24369b04&scoped=true"
import script from "./allNewDetails.vue?vue&type=script&lang=js"
export * from "./allNewDetails.vue?vue&type=script&lang=js"
import style0 from "./allNewDetails.vue?vue&type=style&index=0&id=24369b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24369b04",
  null
  
)

export default component.exports